require('../../scss/loader.scss');

$(window).on('load', function () {
    $('#page-loader').fadeOut(200);
});
window.onbeforeunload = function (event) {
    $('#page-loader').fadeIn(200);
};


// WEBPACK FOOTER //
// ./app/Resources/assets/js/front/loader.jsx